import React, {useRef, useState} from 'react';
import {TabPanel, TabView} from 'primereact/tabview';
import {InputNumber} from 'primereact/inputnumber';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {InputText} from 'primereact/inputtext';
import {Toast} from 'primereact/toast';
import {Dropdown} from 'primereact/dropdown';
import {Tag} from 'primereact/tag';
import {MainLayout} from "../../components/MainLayout";
import './LookupManagement.scss';
import {showToast} from "../../helpers/showToast";

const LookupManagementComponent = ({
                                       tab,
                                       isic4,
                                       onAddIsic4,
                                       onUpdateIsic4,
                                       onToggleIsic4Status,
                                       currencies,
                                       onAddCurrency,
                                       onUpdateCurrency,
                                       onToggleCurrencyStatus,
                                       invoiceTypes,
                                       provinces,
                                       additionalBuyerIdTypes,
                                       onAddInvoiceType,
                                       onUpdateInvoiceType,
                                       onToggleInvoiceTypeStatus,
                                       onToggleAdditionalBuyerIdTypeStatus,
                                       onAddAdditionalBuyerIdType,
                                       onUpdateAdditionalBuyerIdType,
                                       onUpdateProvince

                                   }) => {
    // Toast reference for notifications
    const toast = useRef(null);


    // State for Currency CRUD
    const [currencyDialog, setCurrencyDialog] = useState(false);
    const [isic4Dialog, setIsic4Dialog] = useState(false);
    const [deleteCurrencyDialog, setDeleteCurrencyDialog] = useState(false);
    const [deleteIsic4Dialog, setDeleteIsic4Dialog] = useState(false);
    const [noteDialog, setNoteDialog] = useState(false);
    const [noteValue, setNoteValue] = useState('');
    const [pendingToggleAction, setPendingToggleAction] = useState(null);
    const [currency, setCurrency] = useState({
        currency: '', rate: 1, englishDescription: '', arabicDescription: '', enabled: true
    });
    const [isic4State, setIsic4] = useState({
        code: 'ISIC4_', englishDescription: '', arabicDescription: '', enabled: true
    });
    const defaultFilters = {
        currency: {global: {value: null, matchMode: "contains"}},
        isic4: {global: {value: null, matchMode: "contains"}},
        invoice: {global: {value: null, matchMode: "contains"}},
        buyerId: {global: {value: null, matchMode: "contains"}},
        province: {global: {value: null, matchMode: "contains"}},
    };
    const [filters, setFilters] = useState(defaultFilters);
    const [submitted, setSubmitted] = useState(false);
    const [noteSubmitted, setNoteSubmitted] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    // Add these state variables after the currency ones
    const [invoiceTypeDialog, setInvoiceTypeDialog] = useState(false);
    const [deleteInvoiceTypeDialog, setDeleteInvoiceTypeDialog] = useState(false);
    const [invoiceType, setInvoiceType] = useState({
        code: 'IT-', descriptionAr: '', descriptionEn: '', xmlDigitReference: 0, allowedPercentage: 0, enabled: true
    });
    const onGlobalFilterChange = (e, key) => {
        const value = e.target.value;
        setFilters((prev) => ({
            ...prev, [key]: {
                ...prev[key], global: {...prev[key].global, value: value || null}
            }
        }));
    };
    const renderHeader = (title, key, addBtn = false, onClick) => (<div className="table-header">
        <h2>{title}</h2>
        <div className="search-and-add">
      <span className="custom-search-input">
        <i className="pi pi-search"/>
        <InputText
            type="search"
            value={filters[key].global.value || ''}
            onChange={(e) => onGlobalFilterChange(e, key)}
            placeholder="Search..."
        />
      </span>
            {addBtn && <Button label="Add New" icon="pi pi-plus" className="custom-add-button" onClick={onClick}/>}
        </div>
    </div>);


    // Add this with your other state variables
    const [taxTypeOptions, setTaxTypeOptions] = useState([{label: 'Not Specified', value: 'NOT_SPECIFIED'}, {
        label: 'ZERO (0%)', value: 'ZERO'
    }]);
    const [additionalBuyerIdTypeDialog, setAdditionalBuyerIdTypeDialog] = useState(false);
    const [deleteAdditionalBuyerIdTypeDialog, setDeleteAdditionalBuyerIdTypeDialog] = useState(false);
    const [additionalBuyerIdType, setAdditionalBuyerIdType] = useState({
        code: '', descriptionAr: '', descriptionEn: '', enabled: true
    });
    const onInputNumberChange = (e, name) => {
        const val = e.value;
        setCurrency(prevState => ({
            ...prevState, [name]: val
        }));
    };
    // Add these state variables
    const [provinceDialog, setProvinceDialog] = useState(false);
    const [province, setProvince] = useState({
        code: '', descriptionAr: '', descriptionEn: ''
    });

    // Add functions for province management
    const hideProvinceDialog = () => {
        setSubmitted(false);
        setProvinceDialog(false);
    };

    const editProvince = (data) => {
        setProvince({...data});
        setEditMode(true);
        setProvinceDialog(true);
    };

    const saveProvince = async () => {
        setSubmitted(true);

        // Field validation
        const validationErrors = [];

        // English description validation
        if (!province.descriptionEn) {
            validationErrors.push("English description is required");
        } else if (province.descriptionEn.length < 4 || province.descriptionEn.length > 30) {
            validationErrors.push("English description must be between 4 and 30 characters");
        } else if (!regexPatterns.en.test(province.descriptionEn)) {
            validationErrors.push("English description must contain only English characters and spaces");
        }

        // Arabic description validation
        if (!province.descriptionAr) {
            validationErrors.push("Arabic description is required");
        } else if (province.descriptionAr.length < 4 || province.descriptionAr.length > 30) {
            validationErrors.push("Arabic description must be between 4 and 30 characters");
        } else {
            // Arabic regex pattern
            const arabicPattern = /^[\u0600-\u06FF\s]+$/;
            if (!arabicPattern.test(province.descriptionAr)) {
                validationErrors.push("Arabic description must contain only Arabic characters");
            }
        }

        // If there are validation errors, show the first one and return
        if (validationErrors.length > 0) {
            toast.current.show({
                severity: 'error', summary: 'Validation Error', detail: validationErrors[0], life: 3000
            });
            return;
        }

        // Continue with API call if validation passes
        const result = await onUpdateProvince(province.code, {
            descriptionEn: province.descriptionEn, descriptionAr: province.descriptionAr
        });

        if (result.success) {
            setProvinceDialog(false);
            setProvince({
                code: '', descriptionAr: '', descriptionEn: ''
            });

            toast.current.show({
                severity: 'success', summary: 'Success', detail: 'Province updated successfully', life: 3000
            });
        } else {
            let errorMsg = 'Operation failed';

            // Extract error message from the response
            if (result.error && result.error.errorMessage) {
                errorMsg = result.error.errorMessage;
            }

            toast.current.show({
                severity: 'error', summary: 'Error', detail: errorMsg, life: 5000
            });
        }
    };

    // Province Dialog Footer
    const provinceDialogFooter = (<React.Fragment>
        {/* Add the p-button-sm class to both buttons */}
        <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text p-button-sm"
            onClick={hideProvinceDialog}
        />
        <Button
            label="Update"
            icon="pi pi-check"
            className="p-button-blue p-button-sm"
            style={{marginLeft: "2.5rem"}}
            onClick={saveProvince}
        />
    </React.Fragment>);

    // Table header for provinces
    const provinceHeader = (<div className="table-header">
        <h2>Province Management</h2>
        <div className="search-and-add">
                <span className="custom-search-input">
                    <i className="pi pi-search"/>
                    <InputText
                        type="search"
                        // value={filtersCurrency.global.value || ''}
                        onChange={onGlobalFilterChange}
                        placeholder="Search..."
                    />
                </span>
        </div>
    </div>);
    const openNewAdditionalBuyerIdType = () => {
        setAdditionalBuyerIdType({
            code: '', descriptionAr: '', descriptionEn: '', enabled: true
        });
        setSubmitted(false);
        setEditMode(false);
        setAdditionalBuyerIdTypeDialog(true);
    };

    const hideAdditionalBuyerIdTypeDialog = () => {
        setSubmitted(false);
        setAdditionalBuyerIdTypeDialog(false);
    };

    const hideDeleteAdditionalBuyerIdTypeDialog = () => {
        setDeleteAdditionalBuyerIdTypeDialog(false);
    };

    const editAdditionalBuyerIdType = (data) => {
        setAdditionalBuyerIdType({...data});
        setEditMode(true);
        setAdditionalBuyerIdTypeDialog(true);
    };

    const toggleAdditionalBuyerIdTypeStatus = (rowData) => {
        setPendingToggleAction({
            code: rowData.code, newStatus: !rowData.enabled, type: 'additionalBuyerIdType'
        });
        setNoteValue('');
        setNoteSubmitted(false);
        setNoteDialog(true);
    };

    const saveAdditionalBuyerIdType = async () => {
        setSubmitted(true);

        // Field validation
        const validationErrors = [];

        // Code validation - must be between 2 and 5 characters
        if (!additionalBuyerIdType.code) {
            validationErrors.push("Code is required");
        } else if (additionalBuyerIdType.code.length < 2 || additionalBuyerIdType.code.length > 5) {
            validationErrors.push("Code must be between 2 and 5 characters");
        }

        // English description validation
        if (!additionalBuyerIdType.descriptionEn) {
            validationErrors.push("English description is required");
        } else if (additionalBuyerIdType.descriptionEn.length < 4 || additionalBuyerIdType.descriptionEn.length > 30) {
            validationErrors.push("English description must be between 4 and 30 characters");
        } else if (!regexPatterns.en.test(additionalBuyerIdType.descriptionEn)) {
            validationErrors.push("English description must contain only English characters and spaces");
        }

        // Arabic description validation
        if (!additionalBuyerIdType.descriptionAr) {
            validationErrors.push("Arabic description is required");
        } else if (additionalBuyerIdType.descriptionAr.length < 4 || additionalBuyerIdType.descriptionAr.length > 30) {
            validationErrors.push("Arabic description must be between 4 and 30 characters");
        } else {
            // Arabic regex pattern
            const arabicPattern = regexPatterns.ar;
            if (!arabicPattern.test(additionalBuyerIdType.descriptionAr)) {
                validationErrors.push("Arabic description must contain only Arabic characters");
            }
        }

        // If there are validation errors, show the first one and return
        if (validationErrors.length > 0) {
            toast.current.show({
                severity: 'error', summary: 'Validation Error', detail: validationErrors[0], life: 3000
            });
            return;
        }

        // Continue with API call if validation passes
        let result;
        if (editMode) {
            // Update existing additional buyer ID type
            result = await onUpdateAdditionalBuyerIdType(additionalBuyerIdType.code, {
                descriptionEn: additionalBuyerIdType.descriptionEn, descriptionAr: additionalBuyerIdType.descriptionAr
            });
        } else {
            // Create new additional buyer ID type
            result = await onAddAdditionalBuyerIdType(additionalBuyerIdType);
        }

        if (result.success) {
            setAdditionalBuyerIdTypeDialog(false);
            setAdditionalBuyerIdType({
                code: '', descriptionAr: '', descriptionEn: '', enabled: true
            });

            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: editMode ? 'Additional Buyer ID Type updated successfully' : 'Additional Buyer ID Type created successfully',
                life: 3000
            });
        } else {
            let errorMsg = 'Operation failed';

            // Extract error message from the response
            if (result.error && result.error.errorMessage) {
                errorMsg = result.error.errorMessage;
            }

            toast.current.show({
                severity: 'error', summary: 'Error', detail: errorMsg, life: 5000
            });
        }
    };

    const deleteAdditionalBuyerIdType = () => {
        setPendingToggleAction({
            code: additionalBuyerIdType.code, newStatus: false, type: 'additionalBuyerIdType'
        });
        setNoteValue('');
        setNoteSubmitted(false);
        setDeleteAdditionalBuyerIdTypeDialog(false);
        setNoteDialog(true);
    };
    const confirmToggleWithNote = async () => {
        setNoteSubmitted(true);

        if (!noteValue || noteValue.length < 4 || noteValue.length > 30) {
            return;
        }

        setNoteDialog(false);

        let result;
        if (pendingToggleAction.type === 'invoiceType') {
            result = await onToggleInvoiceTypeStatus(pendingToggleAction.code, pendingToggleAction.newStatus, noteValue);
        } else if (pendingToggleAction.type === 'additionalBuyerIdType') {
            result = await onToggleAdditionalBuyerIdTypeStatus(pendingToggleAction.code, pendingToggleAction.newStatus, noteValue);
        } else if (pendingToggleAction.type === 'isic4') {
            result = await onToggleIsic4Status(pendingToggleAction.code, pendingToggleAction.newStatus, noteValue);
        } else {
            result = await onToggleCurrencyStatus(pendingToggleAction.code, pendingToggleAction.newStatus, noteValue);
        }

        if (result.success) {
            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: `${pendingToggleAction.type === 'invoiceType' ? 'Invoice type' : pendingToggleAction.type === 'additionalBuyerIdType' ? 'Additional Buyer ID Type' : pendingToggleAction.type === 'isic4' ? 'ISIC4' : 'Currency'} ${result.data.enabled ? 'enabled' : 'disabled'} successfully`,
                life: 3000
            });
        } else {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: `Failed to update ${pendingToggleAction.type === 'invoiceType' ? 'invoice type' : pendingToggleAction.type === 'additionalBuyerIdType' ? 'additional buyer ID type' : pendingToggleAction.type === 'isic4' ? 'isic4' : 'currency'} status`,
                life: 3000
            });
        }
    };

    // Additional Buyer ID Type Dialog footer
    const additionalBuyerIdTypeDialogFooter = (<React.Fragment>
        <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text p-button-sm"
            onClick={hideAdditionalBuyerIdTypeDialog}
        />
        <Button
            label={editMode ? "Update" : "Save"}
            icon="pi pi-check"
            className="p-button-blue p-button-sm"
            style={{marginLeft: "2.5rem"}}
            onClick={saveAdditionalBuyerIdType}
        />
    </React.Fragment>);

    // Delete Additional Buyer ID Type Dialog Footer
    const deleteAdditionalBuyerIdTypeDialogFooter = (<React.Fragment>
        <Button
            label="No"
            icon="pi pi-times"
            className="p-button-text p-button-sm"
            onClick={hideDeleteAdditionalBuyerIdTypeDialog}
        />
        <Button
            label="Yes"
            icon="pi pi-check"
            className="p-button-blue p-button-sm"
            style={{marginLeft: "2.5rem"}}
            onClick={deleteAdditionalBuyerIdType}
        />
    </React.Fragment>);

    // Table header for additional buyer ID types
    const additionalBuyerIdTypeHeader = (<div className="table-header">
        <h2>Additional Buyer ID Type Management</h2>
        <div className="search-and-add">
                <span className="custom-search-input">
                    <i className="pi pi-search"/>
                    <InputText
                        type="search"
                        onChange={onGlobalFilterChange}
                        placeholder="Search..."
                    />
                </span>
            <Button
                label="Add New"
                icon="pi pi-plus"
                className="custom-add-button" /* Apply the custom class to the button */
                onClick={openNewAdditionalBuyerIdType}
            />
        </div>
    </div>);

    // Open new invoice type dialog
    const openNewInvoiceType = () => {
        setInvoiceType({
            code: 'IT-', descriptionAr: '', descriptionEn: '', xmlDigitReference: 0, allowedPercentage: 0, enabled: true
        });
        setSubmitted(false);
        setEditMode(false);
        setInvoiceTypeDialog(true);
    };

    // Hide the invoice type dialog
    const hideInvoiceTypeDialog = () => {
        setSubmitted(false);
        setInvoiceTypeDialog(false);
    };

    // Hide the delete invoice type dialog
    const hideDeleteInvoiceTypeDialog = () => {
        setDeleteInvoiceTypeDialog(false);
    };
    const editInvoiceType = (invoiceTypeData) => {
        setInvoiceType({
            ...invoiceTypeData,
            // null/undefined maps to the 'NOT_SPECIFIED' sentinel so the dropdown shows "Not Specified"
            allowedPercentage: invoiceTypeData.allowedPercentage == null ? 'NOT_SPECIFIED' : invoiceTypeData.allowedPercentage
        });
        setEditMode(true);
        setInvoiceTypeDialog(true);
    };

    const toggleInvoiceTypeStatus = (rowData) => {
        setPendingToggleAction({
            code: rowData.code, newStatus: !rowData.enabled, type: 'invoiceType'
        });
        setNoteValue('');
        setNoteSubmitted(false);
        setNoteDialog(true);
    };
    const saveInvoiceType = async () => {
        setSubmitted(true);
        invoiceType.descriptionEn = invoiceType.descriptionEn.trimStart();
        invoiceType.descriptionAr = invoiceType.descriptionAr.trimStart();

        // Field validation
        const validationErrors = [];

        // Code validation - must be exactly 6 characters
        if (!invoiceType.code) {
            validationErrors.push("Invoice Type Code is required");
        } else if (invoiceType.code.length !== 6) {
            validationErrors.push("Code must be exactly 6 characters");
        }

        // English description validation
        if (!invoiceType.descriptionEn) {
            validationErrors.push("English description is required");
        } else if (invoiceType.descriptionEn.length < 4 || invoiceType.descriptionEn.length > 30) {
            validationErrors.push("English description must be between 4 and 30 characters");
        } else if (!regexPatterns.en.test(invoiceType.descriptionEn)) {
            validationErrors.push("English description must contain only English characters and spaces");
        }

        // Arabic description validation
        if (!invoiceType.descriptionAr) {
            validationErrors.push("Arabic description is required");
        } else if (invoiceType.descriptionAr.length < 4 || invoiceType.descriptionAr.length > 30) {
            validationErrors.push("Arabic description must be between 4 and 30 characters");
        } else {
            // Arabic regex pattern - this is simpler than the backend version but provides basic validation
            const arabicPattern = regexPatterns.ar;
            if (!arabicPattern.test(invoiceType.descriptionAr)) {
                validationErrors.push("Arabic description must contain only Arabic characters");
            }
        }

        // XML Digit Reference validation
        if (invoiceType.xmlDigitReference === undefined || invoiceType.xmlDigitReference === null) {
            validationErrors.push("XML Digit Reference is required");
        } else if (invoiceType.xmlDigitReference < 0 || invoiceType.xmlDigitReference > 9) {
            validationErrors.push("XML Digit Reference must be between 0 and 9");
        }

        // Allowed Tax Type validation - must be one of the allowed options
        if (!editMode && !taxTypeOptions.some(option => option.value === invoiceType.allowedPercentage)) {
            validationErrors.push("Please select a valid Allowed Tax Type");
        }

        // If there are validation errors, show the first one and return
        if (validationErrors.length > 0) {
            toast.current.show({
                severity: 'error', summary: 'Validation Error', detail: validationErrors[0], life: 3000
            });
            return;
        }

        // Continue with API call if validation passes
        let result;
        if (editMode) {
            // Update existing invoice type
            result = await onUpdateInvoiceType(invoiceType.code, {
                descriptionEn: invoiceType.descriptionEn,
                descriptionAr: invoiceType.descriptionAr,
                xmlDigitReference: invoiceType.xmlDigitReference,
                allowedPercentage: invoiceType.allowedPercentage === 'NOT_SPECIFIED' ? null : invoiceType.allowedPercentage
            });
        } else {
            // Create new invoice type ('NOT_SPECIFIED' sentinel maps back to null for the backend)
            result = await onAddInvoiceType({
                ...invoiceType,
                allowedPercentage: invoiceType.allowedPercentage === 'NOT_SPECIFIED' ? null : invoiceType.allowedPercentage
            });
        }

        if (result.success) {
            setInvoiceTypeDialog(false);
            setInvoiceType({
                code: '',
                descriptionAr: '',
                descriptionEn: '',
                xmlDigitReference: 0,
                allowedPercentage: null,
                enabled: true
            });

            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: editMode ? 'Invoice type updated successfully' : 'Invoice type created successfully',
                life: 3000
            });
        } else {
            let errorMsg = 'Operation failed';

            // Extract error message from the response
            if (result.error && result.error.errorMessage) {
                errorMsg = result.error.errorMessage;
            }

            // toast.current.show({
            //     severity: 'error', summary: 'Error', detail: errorMsg, life: 5000
            // });
        }
    };
    // Delete invoice type
    const deleteInvoiceType = () => {
        setPendingToggleAction({
            code: invoiceType.code, newStatus: false, type: 'invoiceType'
        });
        setNoteValue('');
        setNoteSubmitted(false);
        setDeleteInvoiceTypeDialog(false);
        setNoteDialog(true);
    };

    // Invoice Type Dialog Footer
    const invoiceTypeDialogFooter = (<React.Fragment>
        <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text p-button-sm"
            onClick={hideInvoiceTypeDialog}
        />
        <Button
            label={editMode ? "Update" : "Save"}
            icon="pi pi-check"
            className="p-button-blue p-button-sm"
            style={{marginLeft: "2.5rem"}}
            onClick={saveInvoiceType}
        />
    </React.Fragment>);

    // Delete Invoice Type Dialog Footer
    const deleteInvoiceTypeDialogFooter = (<React.Fragment>
        <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteInvoiceTypeDialog}/>
        <Button label="Yes" icon="pi pi-check" className="p-button-danger" onClick={deleteInvoiceType}/>
    </React.Fragment>);

    // Table header for invoice types
    const invoiceTypeHeader = (<div className="table-header">
        <h2>Invoice Type Management</h2>
        <div className="search-and-add">
                <span className="custom-search-input">
                    <i className="pi pi-search"/>
                    <InputText
                        type="search"
                        onChange={onGlobalFilterChange}
                        placeholder="Search..."
                    />
                </span>

            <Button
                label="Add New"
                icon="pi pi-plus"
                className="custom-add-button" /* Apply the custom class to the button */
                onClick={openNewInvoiceType}
            />
        </div>
    </div>);
    // Open new currency dialog
    const openNew = () => {
        setCurrency({
            currency: '', rate: 1, englishDescription: '', arabicDescription: '', enabled: true
        });
        setSubmitted(false);
        setEditMode(false);
        setCurrencyDialog(true);
    };
    const openNewIsic4 = () => {
        setIsic4({
            code: 'ISIC4_', englishDescription: '', arabicDescription: ''
        });
        setSubmitted(false);
        setEditMode(false);
        setIsic4Dialog(true);
    };

    // Hide the currency dialog
    const hideDialog = () => {
        setSubmitted(false);
        setCurrencyDialog(false);
    };
    const hideIsic4Dialog = () => {
        setSubmitted(false);
        setIsic4Dialog(false);
    };

    // Hide the delete currency dialog
    const hideDeleteCurrencyDialog = () => {
        setDeleteCurrencyDialog(false);
    };
    const hideDeleteIsic4Dialog = () => {
        setDeleteIsic4Dialog(false);
    };

    // Hide the note dialog
    const hideNoteDialog = () => {
        setNoteSubmitted(false);
        setNoteDialog(false);
    };

    // Edit currency
    const editCurrency = (currencyData) => {
        setCurrency({
            ...currencyData, // Map the API field names to the field names used in your form
            englishDescription: currencyData.descriptionEn, arabicDescription: currencyData.descriptionAr
        });
        setEditMode(true);
        setCurrencyDialog(true);
    }
    const editIsic4 = (isic4Data) => {
        setIsic4({
            ...isic4Data, // Map the API field names to the field names used in your form
            englishDescription: isic4Data.descriptionEn, arabicDescription: isic4Data.descriptionAr
        });
        setEditMode(true);
        setIsic4Dialog(true);
    }

    // Toggle currency enabled/disabled status
    const toggleStatus = (rowData) => {
        setPendingToggleAction({
            code: rowData.currency, newStatus: !rowData.enabled
        });
        setNoteValue('');  // Clear previous note
        setNoteSubmitted(false);
        setNoteDialog(true);
    };
    const toggleIsic4Status = (rowData) => {
        setPendingToggleAction({
            code: rowData.code, newStatus: !rowData.enabled, type: 'isic4'
        });
        setNoteValue('');  // Clear previous note
        setNoteSubmitted(false);
        setNoteDialog(true);
    };


    // Save currency (create or update)
    const saveCurrency = async () => {
        setSubmitted(true);

        const arabicValidate = validationError(submitted, currency.arabicDescription.trimStart(), 'ar');
        const englishValidate = validationError(submitted, currency.englishDescription.trimStart(), 'en');

        // Validation using new field names
        if (!currency.currency || englishValidate || arabicValidate || !currency.rate) {
            console.log("Validation failed. Current currency state:", currency);
            showToast({
                toastOptions: {type: "error",}, data: {
                    text: "Please fill the required fields",
                },
            });
            return;
        }

        console.log("Saving currency with data:", currency);

        let result;
        if (editMode) {
            // Update existing currency
            result = await onUpdateCurrency(currency.currency, {
                descriptionEn: currency.englishDescription,
                descriptionAr: currency.arabicDescription,
                rate: currency.rate
            });
        } else {
            // Create new currency - ensure all fields are included
            const currencyData = {
                currency: currency.currency,
                rate: currency.rate,
                arabicDescription: currency.arabicDescription,
                englishDescription: currency.englishDescription
            };
            console.log("Sending to onAddCurrency:", currencyData);
            result = await onAddCurrency(currencyData);
        }

        console.log("Result from API:", result);

        if (result.success) {
            setCurrencyDialog(false);
            setCurrency({
                currency: '', rate: 1, englishDescription: '', arabicDescription: '', enabled: true
            });

            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: editMode ? 'Currency updated successfully' : 'Currency created successfully',
                life: 3000
            });
        } else {
            let errorMsg = 'Operation failed';
            if (result.error && result.error.response && result.error.response.data && result.error.response.data.message) {
                errorMsg = result.error.response.data.message;
            }

            // toast.current.show({
            //     severity: 'error', summary: 'Error', detail: errorMsg, life: 3000
            // });
        }
    };
    const saveIsic4 = async () => {
        setSubmitted(true);

        const arabicValidate = validationError(submitted, isic4State.arabicDescription?.trimStart() || '', 'ar');
        const englishValidate = validationError(submitted, isic4State.englishDescription?.trimStart() || '', 'en');

        // Validation using new field names
        if (!isic4State.code || englishValidate || arabicValidate) {
            console.log("Validation failed. Current currency state:", isic4State);
            return;
        }

        console.log("Saving currency with data:", isic4State);

        let result;
        if (editMode) {
            // Update existing currency
            result = await onUpdateIsic4(isic4State.code, {
                descriptionEn: isic4State.englishDescription, descriptionAr: isic4State.arabicDescription
            });
        } else {
            // Create new currency - ensure all fields are included
            const isic4Data = {
                code: isic4State.code,
                arabicDescription: isic4State.arabicDescription,
                englishDescription: isic4State.englishDescription
            };
            console.log("Sending to onAddIsic4:", isic4Data);
            result = await onAddIsic4(isic4Data);
        }

        console.log("Result from API:", result);

        if (result.success) {
            setIsic4Dialog(false);
            setIsic4({
                code: '', englishDescription: '', arabicDescription: '', enabled: true
            });

            toast.isic4State.show({
                severity: 'success',
                summary: 'Success',
                detail: editMode ? 'Isic4 updated successfully' : 'Isic4 created successfully',
                life: 3000
            });
        } else {
            let errorMsg = 'Operation failed';
            if (result.error && result.error.response && result.error.response.data && result.error.response.data.message) {
                errorMsg = result.error.response.data.message;
            }

            // toast.isic4State.show({
            //     severity: 'error', summary: 'Error', detail: errorMsg, life: 3000
            // });
        }
    };
    // Delete currency (now will show note dialog)
    const deleteCurrency = () => {
        setPendingToggleAction({
            code: currency.currency, newStatus: false
        });
        setNoteValue('');  // Clear previous note
        setNoteSubmitted(false);
        setDeleteCurrencyDialog(false);
        setNoteDialog(true);
    };


    const deleteIsic4 = () => {
        setPendingToggleAction({
            code: isic4State.code, newStatus: false
        });
        setNoteValue('');  // Clear previous note
        setNoteSubmitted(false);
        setDeleteIsic4Dialog(false);
        setNoteDialog(true);
    };

    // Input change handler
    const onInputChange = (e, name) => {
        const val = e.target.value || '';
        setCurrency(prevCurrency => ({
            ...prevCurrency, [name]: val
        }));
    };
    const onIsic4InputChange = (e, name) => {
        const val = e.target.value || '';
        setIsic4(prevIsic4 => ({
            ...prevIsic4, [name]: val
        }));
    };

    // Currency Dialog Footer
    const currencyDialogFooter = (<React.Fragment>
        <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text p-button-sm"
            onClick={hideDialog}
        />
        <Button
            label={editMode ? "Update" : "Save"}
            icon="pi pi-check"
            className="p-button-blue p-button-sm"
            style={{marginLeft: "2.5rem"}}
            onClick={saveCurrency}
        />
    </React.Fragment>);
    const isic4DialogFooter = (<React.Fragment>
        <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text p-button-sm"
            onClick={hideIsic4Dialog}
        />
        <Button
            label={editMode ? "Update" : "Save"}
            icon="pi pi-check"
            className="p-button-blue p-button-sm"
            style={{marginLeft: "2.5rem"}}
            onClick={saveIsic4}
        />
    </React.Fragment>);

    // Delete Currency Dialog Footer
    const deleteCurrencyDialogFooter = (<React.Fragment>
        <Button
            label="No"
            icon="pi pi-times"
            className="p-button-text p-button-sm"
            onClick={hideDeleteCurrencyDialog}
        />
        <Button
            label="Yes"
            icon="pi pi-check"
            className="p-button-blue p-button-sm"
            style={{marginLeft: "2.5rem"}}
            onClick={deleteCurrency}
        />
    </React.Fragment>);
    const deleteIsic4DialogFooter = (<React.Fragment>
        <Button
            label="No"
            icon="pi pi-times"
            className="p-button-text p-button-sm"
            onClick={hideDeleteIsic4Dialog}
        />
        <Button
            label="Yes"
            icon="pi pi-check"
            className="p-button-blue p-button-sm"
            style={{marginLeft: "2.5rem"}}
            onClick={deleteIsic4}
        />
    </React.Fragment>);

    // Note Dialog Footer
    const noteDialogFooter = (<React.Fragment>
        <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideNoteDialog}/>
        <Button
            label="Submit"
            icon="pi pi-check"
            onClick={confirmToggleWithNote}
            disabled={!noteValue || noteValue.length < 4 || noteValue.length > 30}
        />
    </React.Fragment>);

    // Status badge template
    const statusBodyTemplate = (rowData) => {
        return (<Tag
            severity={rowData.enabled ? 'success' : 'danger'}
            value={rowData.enabled ? 'Active' : 'Inactive'}
        />);
    };
    const actionBodyTemplate = (rowData) => {
        return (<div className="actions">
            <button
                className="action-btn edit-btn icon-only"
                onClick={() => editCurrency(rowData)}
                title="Edit"
            >
                <i className="pi pi-pencil"></i>
            </button>
            <button
                className={`action-btn icon-only ${rowData.enabled ? "disable-btn" : "enable-btn"}`}
                onClick={() => toggleStatus(rowData)}
                title={rowData.enabled ? "Disable" : "Enable"}
            >
                <i className={`pi ${rowData.enabled ? "pi-ban" : "pi-check-circle"}`}></i>
            </button>
        </div>);
    };
    const actionIsic4BodyTemplate = (rowData) => {
        return (<div className="actions">
            <button
                className="action-btn edit-btn icon-only"
                onClick={() => editIsic4(rowData)}
                title="Edit"
            >
                <i className="pi pi-pencil"></i>
            </button>
            <button
                className={`action-btn icon-only ${rowData.enabled ? "disable-btn" : "enable-btn"}`}
                onClick={() => toggleIsic4Status(rowData)}
                title={rowData.enabled ? "Disable" : "Enable"}
            >
                <i className={`pi ${rowData.enabled ? "pi-ban" : "pi-check-circle"}`}></i>
            </button>
        </div>);
    };

    const regexPatterns = {
        en: /^[A-Za-z\s]{4,30}$/,        // English letters + spaces
        ar: /^[\u0600-\u06FF\s]{4,30}$/  // Arabic letters + spaces
    };

    const validateValue = (value, lang) => {
        if (!value.trimStart()) {
            return lang === "en" ? "English name is required." : "Arabic name is required.";
        }
        if (!regexPatterns[lang].test(value.trimStart())) {
            return lang === "en" ? "Use only English letters and spaces (4–30 characters)." : "Use only Arabic letters and spaces (4–30 characters).";
        }
        return null; // No error
    };

    const validationError = (submitted, value, lang) => {
        if (!submitted) return null;
        const error = validateValue(value, lang);
        return error ? <small className="p-error">{error}</small> : null;
    }

    const validationClass = (submitted, value, lang) => {
        if (!submitted) return "";

        if (!value.trimStart()) return "p-invalid";
        if (!regexPatterns[lang].test(value.trimStart())) return "p-invalid";

        return "";
    };


    return (<MainLayout tab={tab} withSidebar={true}>
        <Toast ref={toast}/>

        <div className="lookup-management">
            <TabView activeIndex={activeIndex} onTabChange={(e) => {
                setActiveIndex(e.index);
                setFilters(defaultFilters);
            }}>
                <TabPanel header="Currency">
                    <div className="card">
                        <DataTable
                            value={currencies}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25]}
                            className="p-datatable-lookups"
                            dataKey="currency"
                            filters={filters.currency}
                            globalFilterFields={['currency', 'descriptionEn', 'descriptionAr', 'rate']}
                            header={renderHeader("Currency Management", "currency", true, openNew)}
                            emptyMessage="No currencies found."
                            responsiveLayout="scroll"
                        >
                            <Column field="currency" header="Code" sortable style={{minWidth: '12rem'}}/>
                            <Column field="descriptionEn" header="English Name" style={{minWidth: '16rem'}}/>
                            <Column field="descriptionAr" header="Arabic Name" style={{minWidth: '16rem'}}/>
                            <Column field="rate" header="Rate" sortable style={{minWidth: '12rem'}}/>
                            <Column field="enabled" header="Status" body={statusBodyTemplate}
                                    style={{minWidth: '8rem'}}/>
                            <Column body={actionBodyTemplate} exportable={false} style={{minWidth: '10rem'}}/>
                        </DataTable>
                    </div>
                </TabPanel>
                <TabPanel header="ISIC4">
                    <div className="card">
                        <DataTable
                            value={isic4}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25]}
                            className="p-datatable-lookups"
                            dataKey="isic4"
                            filters={filters.isic4}
                            globalFilterFields={['code', 'descriptionEn', 'descriptionAr']}
                            header={renderHeader("Isic4 Management", "isic4", true, openNewIsic4)}
                            emptyMessage="No ISIC4 found."
                            responsiveLayout="scroll"
                        >
                            <Column field="code" header="Code" sortable style={{minWidth: '12rem'}}/>
                            <Column field="descriptionEn" header="English Name" style={{minWidth: '16rem'}}/>
                            <Column field="descriptionAr" header="Arabic Name" style={{minWidth: '16rem'}}/>
                            <Column field="enabled" header="Status" body={statusBodyTemplate}
                                    style={{minWidth: '8rem'}}/>
                            <Column body={actionIsic4BodyTemplate} exportable={false} style={{minWidth: '10rem'}}/>
                        </DataTable>
                    </div>
                </TabPanel>
                <TabPanel header="Invoice Type">
                    <div className="card">
                        <DataTable
                            value={invoiceTypes}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25]}
                            className="p-datatable-lookups"
                            dataKey="code"
                            filters={filters.invoice}
                            globalFilterFields={['code', 'descriptionEn', 'descriptionAr']}
                            header={renderHeader("Invoice Type Management", "invoice", true, openNewInvoiceType)}
                            emptyMessage="No invoice types found."
                            responsiveLayout="scroll"
                        >
                            <Column field="code" header="Code" sortable style={{minWidth: '12rem'}}/>
                            <Column field="descriptionEn" header="English Name" style={{minWidth: '14rem'}}/>
                            <Column field="descriptionAr" header="Arabic Name" style={{minWidth: '14rem'}}/>
                            <Column field="xmlDigitReference" header="XML Ref" style={{minWidth: '8rem'}}/>
                            <Column
                                field="allowedPercentage"
                                header="Allowed Tax Type"
                                style={{minWidth: '10rem'}}
                                body={(rowData) => {
                                    // Handle null case
                                    if (rowData.allowedPercentage === null || rowData.allowedPercentage === undefined) {
                                        return 'Not Specified';
                                    }

                                    // Handle string enum values
                                    const taxTypeMap = {
                                        'ZERO': '0%',
                                        'EXEMPT': '0% (Exempt)',
                                        'ONE': '1%',
                                        'TWO': '2%',
                                        'THREE': '3%',
                                        'FOUR': '4%',
                                        'FIVE': '5%',
                                        'SIX': '6%',
                                        'SEVEN': '7%',
                                        'EIGHT': '8%',
                                        'TEN': '10%',
                                        'SIXTEEN': '16%'
                                    };

                                    // If it's a string enum
                                    if (typeof rowData.allowedPercentage === 'string') {
                                        return taxTypeMap[rowData.allowedPercentage] || rowData.allowedPercentage;
                                    }

                                    // If it's a number
                                    if (typeof rowData.allowedPercentage === 'number') {
                                        // Map numeric values to display text
                                        switch (rowData.allowedPercentage) {
                                            case 0:
                                                return '0%';
                                            case 1:
                                                return '1%';
                                            case 2:
                                                return '2%';
                                            case 3:
                                                return '3%';
                                            case 4:
                                                return '4%';
                                            case 5:
                                                return '5%';
                                            case 6:
                                                return '6%';
                                            case 7:
                                                return '7%';
                                            case 8:
                                                return '8%';
                                            case 10:
                                                return '10%';
                                            case 16:
                                                return '16%';
                                            default:
                                                return `${rowData.allowedPercentage}%`;
                                        }
                                    }

                                    // Fallback for any other formats
                                    return String(rowData.allowedPercentage);
                                }}
                            />
                            <Column field="enabled" header="Status" body={statusBodyTemplate}
                                    style={{minWidth: '8rem'}}/>
                            <Column body={(rowData) => (<div className="actions">
                                <button
                                    className="action-btn edit-btn icon-only"
                                    onClick={() => editInvoiceType(rowData)}
                                    title="Edit"
                                >
                                    <i className="pi pi-pencil"></i>
                                </button>
                                <button
                                    className={`action-btn icon-only ${rowData.enabled ? "disable-btn" : "enable-btn"}`}
                                    onClick={() => toggleInvoiceTypeStatus(rowData)}
                                    title={rowData.enabled ? "Disable" : "Enable"}
                                >
                                    <i className={`pi ${rowData.enabled ? "pi-ban" : "pi-check-circle"}`}></i>
                                </button>
                            </div>)} exportable={false} style={{minWidth: '8rem'}}/>
                        </DataTable>
                    </div>
                </TabPanel>
                <TabPanel header="Additional Buyer ID Type">
                    <div className="card">
                        <DataTable
                            value={additionalBuyerIdTypes}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25]}
                            className="p-datatable-lookups"
                            dataKey="code"
                            filters={filters.buyerId}
                            globalFilterFields={['code', 'descriptionEn', 'descriptionAr']}
                            header={renderHeader("Additional Buyer ID Type Management", "buyerId", true, openNewAdditionalBuyerIdType)}
                            emptyMessage="No additional buyer ID types found."
                            responsiveLayout="scroll"
                        >
                            <Column field="code" header="Code" sortable style={{minWidth: '12rem'}}/>
                            <Column field="descriptionEn" header="English Name" style={{minWidth: '16rem'}}/>
                            <Column field="descriptionAr" header="Arabic Name" style={{minWidth: '16rem'}}/>
                            <Column field="enabled" header="Status" body={statusBodyTemplate}
                                    style={{minWidth: '8rem'}}/>
                            <Column body={(rowData) => (<div className="actions">
                                <button
                                    className="action-btn edit-btn icon-only"
                                    onClick={() => editAdditionalBuyerIdType(rowData)}
                                    title="Edit"
                                >
                                    <i className="pi pi-pencil"></i>
                                </button>
                                <button
                                    className={`action-btn icon-only ${rowData.enabled ? "disable-btn" : "enable-btn"}`}
                                    onClick={() => toggleAdditionalBuyerIdTypeStatus(rowData)}
                                    title={rowData.enabled ? "Disable" : "Enable"}
                                >
                                    <i className={`pi ${rowData.enabled ? "pi-ban" : "pi-check-circle"}`}></i>
                                </button>
                            </div>)} exportable={false} style={{minWidth: '8rem'}}/>
                        </DataTable>
                    </div>
                </TabPanel>
                <TabPanel header="Province">
                    <div className="card">
                        <DataTable
                            value={provinces}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25]}
                            className="p-datatable-lookups"
                            dataKey="code"
                            filters={filters.province}
                            globalFilterFields={['code', 'descriptionEn', 'descriptionAr']}
                            header={renderHeader("Province Management", "province", false)}
                            emptyMessage="No provinces found."
                            responsiveLayout="scroll"
                        >
                            <Column field="code" header="Code" sortable style={{minWidth: '12rem'}}/>
                            <Column field="descriptionEn" header="English Name" style={{minWidth: '16rem'}}/>
                            <Column field="descriptionAr" header="Arabic Name" style={{minWidth: '16rem'}}/>
                            <Column body={(rowData) => (<div className="actions">
                                <button
                                    className="action-btn edit-btn icon-only"
                                    onClick={() => editProvince(rowData)}
                                    title="Edit"
                                >
                                    <i className="pi pi-pencil"></i>
                                </button>
                            </div>)} exportable={false} style={{minWidth: '6rem'}}/>
                        </DataTable>
                    </div>
                </TabPanel>
            </TabView>
        </div>

        {/* Currency Dialog */}
        <Dialog
            visible={currencyDialog}
            style={{width: '450px'}}
            header={editMode ? "Edit Currency" : "Add New Currency"}
            modal
            className="p-fluid"
            footer={currencyDialogFooter}
            onHide={hideDialog}
        >
            <div className="field">
                <label htmlFor="currency">Currency Code* (Letters, numbers, hyphens, underscores)</label>
                <InputText
                    id="currency"
                    value={currency.currency}
                    onChange={(e) => {
                        // Only allow valid characters
                        const value = e.target.value;
                        if (value === '' || /^[A-Za-z0-9\-_]+$/.test(value)) {
                            onInputChange(e, 'currency');
                        }
                    }}
                    required
                    className={submitted && (!currency.currency || !/^[A-Za-z0-9\-_]+$/.test(currency.currency)) ? 'p-invalid' : ''}
                    disabled={editMode}
                    maxLength={3}
                />
                {submitted && !currency.currency && <small className="p-error">Currency code is required.</small>}
                {submitted && currency.currency && !/^[A-Za-z0-9\-_]{3}$/.test(currency.currency) &&
                    <small className="p-error">Currency code must contain only letters, numbers, hyphens, and
                        underscores.</small>}
            </div>
            <br/>
            <div className="field">
                <label htmlFor="rate">Rate*</label>
                <InputNumber
                    id="rate"
                    value={currency.rate}
                    onValueChange={(e) => onInputNumberChange(e, 'rate')}
                    required
                    min={0}
                    mode="decimal"
                    minFractionDigits={2}
                    maxFractionDigits={6}
                    className={submitted && (currency.rate === undefined || currency.rate === null) ? 'p-invalid' : ''}
                />
                {submitted && (currency.rate === undefined || currency.rate === null) &&
                    <small className="p-error">Rate is required.</small>}
            </div>
            <br/>
            <div className="field">
                <label htmlFor="englishDescription">English Name*</label>
                <InputText
                    id="englishDescription"
                    value={currency.englishDescription.trimStart()}
                    onChange={(e) => {

                        onInputChange(e, 'englishDescription');
                    }}
                    required
                    className={validationClass(submitted, currency.englishDescription.trimStart(), 'en')}
                    maxLength={30}
                />
                {validationError(submitted, currency.englishDescription.trimStart(), 'en')}
            </div>
            <br/>
            <div className="field">
                <label htmlFor="arabicDescription">Arabic Name*</label>
                <InputText
                    id="arabicDescription"
                    value={currency.arabicDescription.trimStart()}
                    onChange={(e) => {

                        onInputChange(e, 'arabicDescription');
                    }}
                    required
                    dir="rtl"
                    className={validationClass(submitted, currency.arabicDescription.trimStart(), 'ar')}
                    maxLength={30}
                />
                {validationError(submitted, currency.arabicDescription.trimStart(), 'ar')}
            </div>

        </Dialog>
        {/* Isic4 Dialog */}
        <Dialog
            visible={isic4Dialog}
            style={{width: '450px'}}
            header={editMode ? "Edit Isic4" : "Add New Isic4"}
            modal
            className="p-fluid"
            footer={isic4DialogFooter}
            onHide={hideIsic4Dialog}
        >
            <div className="field">
                <label htmlFor="code">Isic4 Code* (Letters, numbers, hyphens, underscores)</label>
                <InputText
                    id="code"
                    value={isic4State.code}
                    onChange={(e) => {
                        // Only allow valid characters
                        const value = e.target.value;
                        if (value === '' || /^[A-Za-z0-9\-_]+$/.test(value)) {
                            setIsic4({...isic4State, code: value});
                        }
                        if(!value.startsWith('ISIC4_')) {
                            setIsic4({...isic4State, code: 'ISIC4_'});
                        }
                    }}
                    required
                    className={submitted && (!isic4State.code || !/^[A-Za-z0-9\-_]+$/.test(isic4State.code)) ? 'p-invalid' : ''}
                    disabled={editMode}
                    maxLength={10}
                />
                {submitted && (!isic4State.code || isic4State.code === 'ISIC4_') && <small className="p-error">Isic4 code is required.</small>}
                {submitted && !isic4State.englishDescription &&
                    <small className="p-error">English name is required.</small>}

            </div>
            <br/>
            <div className="field">
                <label htmlFor="englishDescription">English Name*</label>
                <InputText
                    id="englishDescription"
                    value={isic4State.englishDescription.trimStart()}
                    onChange={(e) => onIsic4InputChange(e, 'englishDescription')}
                    required

                    className={validationClass(submitted, isic4State.englishDescription.trimStart(), 'en')}
                    maxLength={30}
                />
                {validationError(submitted, isic4State.englishDescription.trimStart(), 'en')}
            </div>
            <br/>
            <div className="field">
                <label htmlFor="arabicDescription">Arabic Name*</label>
                <InputText
                    id="arabicDescription"
                    value={isic4State.arabicDescription.trimStart()}
                    onChange={(e) => onIsic4InputChange(e, 'arabicDescription')}
                    required
                    className={validationClass(submitted, isic4State.arabicDescription.trimStart(), 'ar')}
                    maxLength={30}
                    dir="rtl"
                />
                {validationError(submitted, isic4State.arabicDescription.trimStart(), 'ar')}
            </div>
        </Dialog>

        {/* Delete Currency Dialog */}
        <Dialog
            visible={deleteCurrencyDialog}
            style={{width: '450px'}}
            header="Confirm"
            modal
            footer={deleteCurrencyDialogFooter}
            onHide={hideDeleteCurrencyDialog}
        >
            <div className="confirmation-content">
                <i className="pi pi-exclamation-triangle mr-3" style={{fontSize: '2rem'}}/>
                {currency && (<span>
                            Are you sure you want to disable the currency <b>{currency.descriptionEn}</b>?
                        </span>)}
            </div>
        </Dialog>
        {/* Delete Isic4 Dialog */}
        <Dialog
            visible={deleteIsic4Dialog}
            style={{width: '450px'}}
            header="Confirm"
            modal
            footer={deleteIsic4DialogFooter}
            onHide={hideDeleteIsic4Dialog}
        >
            <div className="confirmation-content">
                <i className="pi pi-exclamation-triangle mr-3" style={{fontSize: '2rem'}}/>
                {isic4State && (<span>
                            Are you sure you want to disable the Isic4 <b>{isic4State.descriptionEn}</b>?
                        </span>)}
            </div>
        </Dialog>

        {/* Note Input Dialog */}
        <Dialog
            visible={noteDialog}
            style={{width: '450px'}}
            header={`Enter Note for ${pendingToggleAction?.newStatus ? 'Enabling' : 'Disabling'}`}
            modal
            className="p-fluid"
            footer={noteDialogFooter}
            onHide={hideNoteDialog}
        >
            <div className="field">
                <label htmlFor="note">Note (4-30 characters)*</label>
                <InputText
                    id="note"
                    value={noteValue}
                    onChange={(e) => setNoteValue(e.target.value.trimStart())}
                    required
                    className={noteSubmitted && (!noteValue || noteValue.length < 4 || noteValue.length > 30) ? 'p-invalid' : ''}
                />
                {noteSubmitted && !noteValue && <small className="p-error">Note is required.</small>}
                {noteSubmitted && noteValue && (noteValue.length < 4 || noteValue.length > 30) &&
                    <small className="p-error">Note must be between 4 and 30 characters.</small>}
            </div>
        </Dialog>
        {/* Invoice Type Dialog */}
        <Dialog
            visible={invoiceTypeDialog}
            style={{width: '450px'}}
            header={editMode ? "Edit Invoice Type" : "Add New Invoice Type"}
            modal
            className="p-fluid"
            footer={invoiceTypeDialogFooter}
            onHide={hideInvoiceTypeDialog}
        >
            <div className="field">
                <label htmlFor="code">Invoice Type Code* (exactly 6 characters, letters, numbers, hyphens,
                    underscores)</label>
                <InputText
                    id="code"
                    value={invoiceType.code}
                    onChange={(e) => {
                        // Only allow valid characters
                        const value = e.target.value;
                        if (value === '' || /^[A-Za-z0-9\-_]*$/.test(value)) {
                            setInvoiceType({...invoiceType, code: value});
                        }
                        if(!value.startsWith('IT-')) {
                            setInvoiceType({...invoiceType, code: 'IT-'});
                        }
                    }}
                    required
                    className={submitted && (!invoiceType.code || invoiceType.code.length !== 6 || !/^[A-Za-z0-9\-_]+$/.test(invoiceType.code)) ? 'p-invalid' : ''}
                    disabled={editMode}
                    maxLength={6}
                />
                {submitted && !invoiceType.code && <small className="p-error">Code is required.</small>}
                {submitted && (!invoiceType.code || invoiceType.code === 'IT-') && <small className="p-error">Code is required.</small>}
                {submitted && invoiceType.code && invoiceType.code.length !== 6 &&
                    <small className="p-error">Code must be exactly 6 characters.</small>}
                {submitted && invoiceType.code && !/^[A-Za-z0-9\-_]+$/.test(invoiceType.code) &&
                    <small className="p-error">Code must contain only letters, numbers, hyphens, and
                        underscores.</small>}
            </div>
            <br/>
            <div className="field">
                <label htmlFor="invoiceTypeDescriptionEn">English Name* (4-30 characters, English only)</label>
                <InputText
                    id="invoiceTypeDescriptionEn"
                    value={invoiceType.descriptionEn}
                    onChange={(e) => setInvoiceType({...invoiceType, descriptionEn: e.target.value})}
                    required
                    className={submitted && (!invoiceType.descriptionEn || !regexPatterns.en.test(invoiceType.descriptionEn) || invoiceType.descriptionEn.length < 4 || invoiceType.descriptionEn.length > 30) ? 'p-invalid' : ''}
                    maxLength={30}
                />
                {submitted && !invoiceType.descriptionEn &&
                    <small className="p-error">English name is required.</small>}
                {submitted && invoiceType.descriptionEn && (invoiceType.descriptionEn.length < 4 || invoiceType.descriptionEn.length > 30) &&
                    <small className="p-error">English name must be between 4 and 30 characters.</small>}
                {submitted && invoiceType.descriptionEn && !regexPatterns.en.test(invoiceType.descriptionEn) &&
                    <small className="p-error">English name must contain only English characters and
                        spaces.</small>}
            </div>
            <br/>
            <div className="field">
                <label htmlFor="invoiceTypeDescriptionAr">Arabic Name* (4-30 characters, Arabic only)</label>
                <InputText
                    id="invoiceTypeDescriptionAr"
                    value={invoiceType.descriptionAr}
                    onChange={(e) => setInvoiceType({...invoiceType, descriptionAr: e.target.value})}
                    required
                    className={submitted && (!invoiceType.descriptionAr || !regexPatterns.ar.test(invoiceType.descriptionAr) || invoiceType.descriptionAr.length < 4 || invoiceType.descriptionAr.length > 30) ? 'p-invalid' : ''}
                    dir="rtl"
                    maxLength={30}
                />
                {submitted && !invoiceType.descriptionAr && <small className="p-error">Arabic name is required.</small>}
                {submitted && invoiceType.descriptionAr && (invoiceType.descriptionAr.length < 4 || invoiceType.descriptionAr.length > 30) &&
                    <small className="p-error">Arabic name must be between 4 and 30 characters.</small>}
                {submitted && invoiceType.descriptionAr && !regexPatterns.ar.test(invoiceType.descriptionAr) &&
                    <small className="p-error">Arabic name must contain only Arabic characters.</small>}
            </div>
            <br/>
            <div className="field">
                <label htmlFor="xmlDigitReference">XML Digit Reference* (0-9)</label>
                <InputText
                    id="xmlDigitReference"
                    type="number"
                    min="0"
                    max="9"
                    value={invoiceType.xmlDigitReference}
                    onChange={(e) => {
                        const value = e.target.value === '' ? '' : parseInt(e.target.value);
                        if (value === '' || (!isNaN(value) && value >= 0 && value <= 9)) {
                            setInvoiceType({...invoiceType, xmlDigitReference: value});
                        }
                    }}
                    className={submitted && (invoiceType.xmlDigitReference === '' || invoiceType.xmlDigitReference === undefined || invoiceType.xmlDigitReference === null || invoiceType.xmlDigitReference < 0 || invoiceType.xmlDigitReference > 9) ? 'p-invalid' : ''}
                    required
                    disabled={editMode} // Disable when in edit mode
                />
                {editMode && <small className="p-info">XML Digit Reference cannot be modified when updating.</small>}
                {submitted && !editMode && (invoiceType.xmlDigitReference === '' || invoiceType.xmlDigitReference === undefined || invoiceType.xmlDigitReference === null) &&
                    <small className="p-error">XML Digit Reference is required.</small>}
                {submitted && !editMode && invoiceType.xmlDigitReference !== '' && invoiceType.xmlDigitReference !== undefined && invoiceType.xmlDigitReference !== null && (invoiceType.xmlDigitReference < 0 || invoiceType.xmlDigitReference > 9) &&
                    <small className="p-error">XML Digit Reference must be between 0 and 9.</small>}
            </div>
            <br/>
            <div className="field">
                <label htmlFor="allowedPercentage">Allowed Tax Type*</label>
                <Dropdown
                    id="allowedPercentage"
                    value={invoiceType.allowedPercentage}
                    options={taxTypeOptions}
                    onChange={(e) => setInvoiceType({...invoiceType, allowedPercentage: e.value})}
                    placeholder="Select Tax Type"
                    className={submitted && !editMode && !taxTypeOptions.some(option => option.value === invoiceType.allowedPercentage) ? 'p-invalid' : ''}
                    required
                    disabled={editMode} // Disable when in edit mode
                />
                {editMode && <small className="p-info">Allowed Tax Type cannot be modified when updating.</small>}
                {submitted && !editMode && !taxTypeOptions.some(option => option.value === invoiceType.allowedPercentage) &&
                    <small className="p-error">Please select a valid Allowed Tax Type.</small>}
            </div>
            {/* <div className="field">
                    <label htmlFor="invoiceTypeEnabled">Status</label>
                    <Dropdown
                        id="invoiceTypeEnabled"
                        value={invoiceType.enabled}
                        options={[
                            { label: 'Active', value: true },
                            { label: 'Inactive', value: false }
                        ]}
                        onChange={(e) => setInvoiceType({ ...invoiceType, enabled: e.value })}
                        placeholder="Select Status"
                    />
                </div> */}
        </Dialog>
        {/* Delete Invoice Type Dialog */}
        <Dialog
            visible={deleteInvoiceTypeDialog}
            style={{width: '450px'}}
            header="Confirm"
            modal
            footer={deleteInvoiceTypeDialogFooter}
            onHide={hideDeleteInvoiceTypeDialog}
        >
            <div className="confirmation-content">
                <i className="pi pi-exclamation-triangle mr-3" style={{fontSize: '2rem'}}/>
                {invoiceType && (<span>
                            Are you sure you want to disable the invoice type <b>{invoiceType.descriptionEn}</b>?
                        </span>)}
            </div>
        </Dialog>
        {/* Additional Buyer ID Type Dialog */}
        <Dialog
            visible={additionalBuyerIdTypeDialog}
            style={{width: '450px'}}
            header={editMode ? "Edit Additional Buyer ID Type" : "Add New Additional Buyer ID Type"}
            modal
            className="p-fluid"
            footer={additionalBuyerIdTypeDialogFooter}
            onHide={hideAdditionalBuyerIdTypeDialog}
        >
            <div className="field">
                <label htmlFor="additionalBuyerIdTypeCode">Code* (2-5 characters, letters, numbers, hyphens,
                    underscores)</label>
                <InputText
                    id="additionalBuyerIdTypeCode"
                    value={additionalBuyerIdType.code}
                    onChange={(e) => {
                        // Only allow valid characters
                        const value = e.target.value;
                        if (value === '' || /^[A-Za-z0-9\-_]*$/.test(value)) {
                            setAdditionalBuyerIdType({...additionalBuyerIdType, code: value});
                        }
                    }}
                    required
                    className={submitted && (!additionalBuyerIdType.code || additionalBuyerIdType.code.length < 2 || additionalBuyerIdType.code.length > 5 || !/^[A-Za-z0-9\-_]+$/.test(additionalBuyerIdType.code)) ? 'p-invalid' : ''}
                    disabled={editMode}
                    maxLength={5}
                />
                {submitted && !additionalBuyerIdType.code && <small className="p-error">Code is required.</small>}
                {submitted && additionalBuyerIdType.code && (additionalBuyerIdType.code.length < 2 || additionalBuyerIdType.code.length > 5) &&
                    <small className="p-error">Code must be between 2 and 5 characters.</small>}
                {submitted && additionalBuyerIdType.code && !/^[A-Za-z0-9\-_]+$/.test(additionalBuyerIdType.code) &&
                    <small className="p-error">Code must contain only letters, numbers, hyphens, and
                        underscores.</small>}
            </div>
            <br/>
            <div className="field">
                <label htmlFor="additionalBuyerIdTypeDescriptionEn">English Name* (4-30 characters, English
                    only)</label>
                <InputText
                    id="additionalBuyerIdTypeDescriptionEn"
                    value={additionalBuyerIdType.descriptionEn.trimStart()}
                    onChange={(e) => setAdditionalBuyerIdType({
                        ...additionalBuyerIdType, descriptionEn: e.target.value
                    })}
                    required
                    className={submitted && (!additionalBuyerIdType.descriptionEn.trimStart() || !regexPatterns.en.test(additionalBuyerIdType.descriptionEn.trimStart()) || additionalBuyerIdType.descriptionEn.trimStart().length < 4 || additionalBuyerIdType.descriptionEn.trimStart().length > 30) ? 'p-invalid' : ''}
                    maxLength={30}
                />
                {submitted && !additionalBuyerIdType.descriptionEn.trimStart() &&
                    <small className="p-error">English name is required.</small>}
                {submitted && additionalBuyerIdType.descriptionEn.trimStart() && (additionalBuyerIdType.descriptionEn.trimStart().length < 4 || additionalBuyerIdType.descriptionEn.trimStart().length > 30) &&
                    <small className="p-error">English name must be between 4 and 30 characters.</small>}
                {submitted && additionalBuyerIdType.descriptionEn.trimStart() && !regexPatterns.en.test(additionalBuyerIdType.descriptionEn.trimStart()) &&
                    <small className="p-error">English name must contain only English characters and
                        spaces.</small>}
            </div>
            <br/>
            <div className="field">
                <label htmlFor="additionalBuyerIdTypeDescriptionAr">Arabic Name* (4-30 characters, Arabic
                    only)</label>
                <InputText
                    id="additionalBuyerIdTypeDescriptionAr"
                    value={additionalBuyerIdType.descriptionAr.trimStart()}
                    onChange={(e) => setAdditionalBuyerIdType({
                        ...additionalBuyerIdType, descriptionAr: e.target.value
                    })}
                    required
                    className={submitted && (!additionalBuyerIdType.descriptionAr.trimStart() || !regexPatterns.ar.test(additionalBuyerIdType.descriptionAr.trimStart()) || additionalBuyerIdType.descriptionAr.trimStart().length < 4 || additionalBuyerIdType.descriptionAr.trimStart().length > 30) ? 'p-invalid' : ''}
                    dir="rtl"
                    maxLength={30}
                />
                {submitted && !additionalBuyerIdType.descriptionAr.trimStart() &&
                    <small className="p-error">Arabic name is required.</small>}
                {submitted && additionalBuyerIdType.descriptionAr.trimStart() && (additionalBuyerIdType.descriptionAr.trimStart().length < 4 || additionalBuyerIdType.descriptionAr.trimStart().length > 30) &&
                    <small className="p-error">Arabic name must be between 4 and 30 characters.</small>}
                {submitted && additionalBuyerIdType.descriptionAr.trimStart() && !regexPatterns.ar.test(additionalBuyerIdType.descriptionAr.trimStart()) &&
                    <small className="p-error">Arabic name must contain only Arabic characters.</small>}
            </div>
        </Dialog>

        {/* Delete Additional Buyer ID Type Dialog */}
        <Dialog
            visible={deleteAdditionalBuyerIdTypeDialog}
            style={{width: '450px'}}
            header="Confirm"
            modal
            footer={deleteAdditionalBuyerIdTypeDialogFooter}
            onHide={hideDeleteAdditionalBuyerIdTypeDialog}
        >
            <div className="confirmation-content">
                <i className="pi pi-exclamation-triangle mr-3" style={{fontSize: '2rem'}}/>
                {additionalBuyerIdType && (<span>
                            Are you sure you want to disable the additional buyer ID type <b>{additionalBuyerIdType.descriptionEn}</b>?
                        </span>)}
            </div>
        </Dialog>
        {/* Province Dialog */}
        <Dialog
            visible={provinceDialog}
            style={{width: '450px'}}
            header="Edit Province"
            modal
            className="p-fluid"
            footer={provinceDialogFooter}
            onHide={hideProvinceDialog}
        >
            <div className="field">
                <label htmlFor="provinceCode">Province Code</label>
                <InputText
                    id="provinceCode"
                    value={province.code}
                    disabled={true}
                />
            </div>
            <br/>
            <div className="field">
                <label htmlFor="provinceDescriptionEn">English Name* (4-30 characters, English only)</label>
                <InputText
                    id="provinceDescriptionEn"
                    value={province.descriptionEn}
                    onChange={(e) => setProvince({...province, descriptionEn: e.target.value})}
                    required
                    className={submitted && (!province.descriptionEn || !regexPatterns.en.test(province.descriptionEn) || province.descriptionEn.length < 4 || province.descriptionEn.length > 30) ? 'p-invalid' : ''}
                    maxLength={30}
                />
                {submitted && !province.descriptionEn && <small className="p-error">English name is required.</small>}
                {submitted && province.descriptionEn && (province.descriptionEn.length < 4 || province.descriptionEn.length > 30) &&
                    <small className="p-error">English name must be between 4 and 30 characters.</small>}
                {submitted && province.descriptionEn && !regexPatterns.en.test(province.descriptionEn) &&
                    <small className="p-error">English name must contain only English characters and
                        spaces.</small>}
            </div>
            <br/>
            <div className="field">
                <label htmlFor="provinceDescriptionAr">Arabic Name* (4-30 characters, Arabic only)</label>
                <InputText
                    id="provinceDescriptionAr"
                    value={province.descriptionAr}
                    onChange={(e) => setProvince({...province, descriptionAr: e.target.value})}
                    required
                    className={submitted && (!province.descriptionAr || !regexPatterns.ar.test(province.descriptionAr) || province.descriptionAr.length < 4 || province.descriptionAr.length > 30) ? 'p-invalid' : ''}
                    dir="rtl"
                    maxLength={30}
                />
                {submitted && !province.descriptionAr && <small className="p-error">Arabic name is required.</small>}
                {submitted && province.descriptionAr && (province.descriptionAr.length < 4 || province.descriptionAr.length > 30) &&
                    <small className="p-error">Arabic name must be between 4 and 30 characters.</small>}
                {submitted && province.descriptionAr && !regexPatterns.ar.test(province.descriptionAr) &&
                    <small className="p-error">Arabic name must contain only Arabic characters.</small>}
            </div>
        </Dialog>
    </MainLayout>);
};

export default React.memo(LookupManagementComponent);
